module.exports = __webpack_public_path__ + "static/media/play.55ff6b01.svg";